import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk/src/sdk.types'
import { StampToolState } from '~/st-doc-viewer/annotations'
import { StampAnnotationElement, StampToolOverlay } from './ui'
import { syncToolStateWithAnnotation } from './tool-state'

export { StampToolEditor } from './ui'

export function stampPlugin(): AnnotationPlugin<StampAnnotation, StampToolState> {
  return {
    name: 'stamp',
    initialToolState: {
      name: 'stamp',
      settings: { templateId: undefined, stampSize: 20 }
    },
    ToolOverlay: StampToolOverlay,
    Element: StampAnnotationElement,
    handlesAnnotation: (annotation) => {
      if (annotation.type != 'stamp') return false
      const stamp = annotation as StampAnnotation
      return stamp.stampType == 'tick_mark' || stamp.stampType == 'number'
    },
    onAnnotationSelected: (event) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        return { type: 'updateTool', tool: syncToolStateWithAnnotation(annotation) }
      }
      return null
    },
    onAnnotationDeselected: (event) => {
      if (event.annotationDraft)
        return { type: 'commitAnnotationDraft', annotationDraft: event.annotationDraft }
      return null
    }
  }
}
